import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import { createTheme } from '@mui/material/styles';
import getDesignTokens from './theme';
import { SnackbarProvider } from './SnackbarContext';

export default function AppProviders({ children }) {
  const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const theme = React.useMemo(() => createTheme(getDesignTokens(prefersDarkMode ? 'dark' : 'light')), [prefersDarkMode]);
  return (
  <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider>
        {children}
      </SnackbarProvider>
    </ThemeProvider>
  );
}
